module.exports = __webpack_public_path__ + "static/glassdoor-338b99ffa01d162e3746790cfa337331.png";